const {StyleSheet} = require("@react-pdf/renderer");

module.exports = StyleSheet.create({
  body: {
    fontFamily: 'HelveticaNow',
    padding: 45.84,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '9.36px 11px',
    fontSize: 10,
    color: '#FFF',
    backgroundColor: '#000',
    textTransform: 'uppercase'
  },
  sectionTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 24
  },
  sectionTitleCircle: {
    width: 11,
    height: 11,

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',

    backgroundColor: '#000',
    borderRadius: '50%'
  },
  sectionTitleIndex: {
    fontSize: 6,
    lineHeight: 0,
    color: '#FFF'
  },
  sectionTitleText: {
    marginLeft: 5,
    fontSize: 10,
    fontWeight: '700',
    textTransform: 'uppercase'
  },
  sectionSubtitle: {
    fontSize: 8,
    fontWeight: '700'
  },
  section: {
    paddingTop: 11,
    paddingRight: 16,
    paddingBottom: 14,
    paddingLeft: 16,
  },
  sectionRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginLeft: -9,
    marginRight: -9,
    boxSizing: 'border-box',
  },
  sectionCol: {
    width: '25%',
    marginTop: 9,
    paddingLeft: 9,
    paddingRight: 9,
    boxSizing: 'border-box'
  },
  sectionBorder: {
    border: '1px solid #595B5E',
    borderRadius: '5px',
  },
  sectionItem: {
    fontSize: 7
  },
  sectionItemTitle: {
    color: '#595B5E'
  },
  sectionItemText: {
    marginTop: 2,
    fontWeight: '700'
  },
})
